import React, { useEffect } from "react";
import uitoolkit from '@zoom/videosdk-ui-toolkit';
import '@zoom/videosdk-ui-toolkit/dist/videosdk-ui-toolkit.css';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchLiveZoomSessionsRequest, getAppointmentDetails, startCloudRecordingRequest } from "../shared/_services/common.services";
import _ from "lodash";
import momentTz from "moment-timezone";
import { useSnackbar } from "notistack";

export default function Zoom() {
    const { id } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    
    

    const MAX_RETRIES = 10; // Maximum number of retries
    const POLL_INTERVAL = 3000; // Polling interval in milliseconds (3 seconds)

    const pollForLiveSession = async (id,appointmentDetails, retries = 0) => {
        if (retries >= MAX_RETRIES) {
            console.error("Max retries reached, session not found.");
            return;
        }

        try {
            
            const sessionResponse = await fetchLiveZoomSessionsRequest({ appointmentDetails });
            
            const sessionFound = sessionResponse?.liveSessions?.sessions?.find(session => !!session.id);

            if (sessionFound) {
                
                handleRecordingStart(id, appointmentDetails);
            } else {
                
                setTimeout(() => pollForLiveSession(id,appointmentDetails, retries + 1), POLL_INTERVAL);
            }
        } catch (error) {
            
           
            setTimeout(() => pollForLiveSession(id,appointmentDetails, retries + 1), POLL_INTERVAL);
        }
    };

    const handleRecordingStart =async (id, appointmentDetails)=>{
        try {
            await startCloudRecordingRequest({ id, appointmentDetails });
            
        } catch (error) {
        }
    }

    const sessionJoined =  (appointmentDetails) => {
        
        if (id && !_.isEmpty(appointmentDetails)) {
            pollForLiveSession(id,appointmentDetails)
        }
        
    };



    const sessionClosed = () => {
        
        navigate("/dashboard");
    };

    const joinMeeting = async (id) => {
        
        try {
            
            let userTimezone = momentTz.tz.guess(true);
            const response = await getAppointmentDetails(id,userTimezone);
            const data = response?.data;
            
            

            if (!data || !data.video_jwt_token) {
                navigate("/appointment");
                return;
            }

            const currentUser = JSON.parse(localStorage.getItem("currentUser"));
            const userName = `${currentUser.user.firstName} ${currentUser.user.lastName}`;

            const config = {
                videoSDKJWT: data.video_jwt_token,
                sessionName: data.session_name,
                userName: userName,
                sessionPasscode: '', // Add session passcode if needed
                features: ['video', 'audio', 'share', 'chat', 'users', 'settings']
            };

            const sessionContainer = document.getElementById('sessionContainer');
            uitoolkit.joinSession(sessionContainer, config);

            // Event listeners
            uitoolkit.onSessionJoined(() => sessionJoined(data));
            uitoolkit.onSessionClosed(sessionClosed);

        } catch (error) {
            let errorMessage = "An error occurred while joining the meeting.";
            if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
                errorMessage = error.response.data.error.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            enqueueSnackbar(errorMessage, {
                variant: 'error',
                anchorOrigin: { horizontal: 'right', vertical: 'top' },
              });
            navigate("/dashboard");
        }
    };

    useEffect(() => {
        if(!id) return ;
        joinMeeting(id);
    }, [id]); 
    return (
        <div className="stars-dark tw-min-h-screen tw-bg-bg tw-text-text">
            <div id='sessionContainer' className="tw-m-auto tw-flex tw-w-full tw-items-center tw-justify-center"></div>
        </div>
    );
}
